import 'isomorphic-fetch';
import queryString from 'query-string';
import { cloneDeep } from 'lodash';

export const CALL_API = Symbol('Call API');

export const CONTENT_TYPE = {
  JSON: Symbol('json'),
  FORM: Symbol('form'),
};

function callApi(url, params, method = 'GET', type = CONTENT_TYPE.JSON, headers = {}) {
  const fullUrl = url;
  const fetchOptions = {
    mode: 'cors',
    method,
    headers: cloneDeep(headers),
    credentials: 'include',
  };

  fetchOptions.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  fetchOptions.body = queryString.stringify(params);

  return fetch(fullUrl, fetchOptions)
  .then(response => {
    return { response };
  })
  .then(({ response }) => {
    if (!response.ok) {
      return Promise.reject({
        'status': response.status,
        'message': response.statusText,
        'httpStatus': response.status,
      });
    }
  });
}

export default store => next => action => {
  const { app: { application: { headers } } } = store.getState();
  const callAPI = action[CALL_API];
  if (typeof(callAPI) === 'undefined') {
    return next(action);
  }

  function actionWith(data) {
    const finalAction = Object.assign({}, action, data);
    delete finalAction[CALL_API];
    return finalAction;
  }

  const { types, params, method, contentType, url, onSuccess, onFail, shouldCamelizedJson } = callAPI;

  const [requestType, successType, failureType] = types;
  next(actionWith({
    type: requestType,
  }));

  return callApi(url, params, method, contentType, headers, shouldCamelizedJson).then(
      response => {
        next(actionWith({
          response,
          type: successType,
        }));

        if (typeof onSuccess === 'function') {
          onSuccess(response);
        }

        return Promise.resolve(response);
      },
      (error) => {
        next(actionWith({
          type: failureType,
          error,
        }));

        if (typeof onFail === 'function') {
          onFail(error);
        }

        return Promise.reject(error);
      }
  );
};



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/screens/Tube/utils/oldApi.js
 **/